var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdvertenciaAmarillo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.94 18.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pol\\xEDgono 1",
    d: "M8.75 1A2 2 0 0111.5.29a1.93 1.93 0 01.68.68l8.47 14.11a2 2 0 01-.65 2.75 2.1 2.1 0 01-1 .28H2a2 2 0 01-1.71-3z",
    fill: "#fce301"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5472"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 3519",
    d: "M10.45 15.43A.4.4 0 0110 15V8.09a.41.41 0 01.41-.41.41.41 0 01.41.41V15a.4.4 0 01-.4.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Elipse 810",
    cx: 10.45,
    cy: 5.45,
    rx: 0.9,
    ry: 0.89
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertenciaAmarillo);
export default __webpack_public_path__ + "static/media/advertencia-amarillo.f98feef9.svg";
export { ForwardRef as ReactComponent };